const fallbackApiBase = 'https://localhost:8080';

export const API_BASE_URL = (
  import.meta.env.VITE_API_URL || fallbackApiBase
).replace(/\/$/, '');
